import ListView from "./ListView/ListView";

const Vehicle = () => <p>Vehicle</p>;

Vehicle.ListView = ListView;
export default Vehicle;
